import { useRef, useEffect, Fragment } from 'react';
import { Button, Modal } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import { attachSignature,  useIsMobileApp } from '../../store/api/CommonFunctions';
import { CheckLg, EraserFill } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature, faTimes } from '@fortawesome/free-solid-svg-icons';
export default function ModalSignature(props) {
    const { popData, setPopData } = props;
    const isMobile = useIsMobileApp();
    const clear = () => sigCanvas.current.clear();
    const save = () => {
        const imageUrl = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        const onSave = () => {
            if (popData.onSave) {
                popData.onSave();
            }
            setPopData({ show: false });
        }
        if (!imageUrl) {
            return;
        }
        fetch(imageUrl)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], "Signature_" + popData.parentType + popData.parentID + ".png", { type: "image/png" });
                attachSignature(popData.parentID, popData.parentType, file, onSave);
            });
    }
    const sigCanvas = useRef({});
    useEffect(() => {
        if (popData.show && !(popData.signatureData?.length > 5)) {
            const canvas = document.querySelector(".signatureCanvas");
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
        }
    }, [popData.show]);
    const close = () => {
        setPopData({ show: false });
        if (popData.onClose) {
            popData.onClose();
        }
    }
    return (
        <Modal size="lg" show={popData.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faFileSignature} size='lg' />&nbsp;
                    دریافت امضا
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle' >
                {
                    popData.signatureData?.length > 5 ?
                        <img src={"data:image;base64," + popData.signatureData} atl='' style={{ display: "block", margin: "auto", width:isMobile?"100%":"unset"}} /> :
                        <Fragment>
                            <SignatureCanvas ref={sigCanvas} canvasProps={{ className: 'signatureCanvas', }} />
                            <Button className="group-Btn" variant='info' onClick={save}><CheckLg size={16} /> ثبت امضا</Button>
                            <Button className="group-Btn" variant='danger' onClick={clear}><EraserFill size={16} /> پاک کردن صفحه</Button>
                        </Fragment>
                }
            </Modal.Body>
        </Modal>
    );
}
